module.exports = __webpack_public_path__ + "media/about/adam-43d5de2f.jpg";